module.exports = __webpack_public_path__ + "static/media/hitPlane3.4cceea32.wav";